enum Visibility {
    ON_SITE = 'on-site',
    OFF_SITE = 'off-site',
    EVERYWHERE = 'everywhere'
}

export default Visibility